<template>
  <div class="location">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Location</h3>
      </section>
      <section class="sub-body-content">

        <v-container fluid>

          <div class="location-map-box map01">
            <!-- <iframe width="100%" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1586.8917150185328!2d127.06938145815477!3d37.300266294962206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5b00b6c8fa2b%3A0xaf803d7d29f0f8f1!2z6rSR6rWQ7Jqw66-464m067iMIChBLEIsQ-uPmSk!5e0!3m2!1sko!2skr!4v1581568361739!5m2!1sko!2skr" allowfullscreen=""></iframe> -->

            <div id="daumRoughmapContainer1643244156194" class="root_daum_roughmap root_daum_roughmap_landing" style="width:100%; height:450px;"></div>
            <div class="d-block d-md-flex px-5 px-sm-15 py-5 py-sm-8">
              <h4 class="text-h5 text-md-h4 font-weight-bold">
                <img src="@/assets/logo_header_d.svg">
                본사
              </h4>
              <p>
                <span>(16942)경기도 용인시 수지구 광교중앙로 338 (상현동, 광교우미뉴브 B동 310호)</span>
                <span>Tel: (031) 719-7805  Fax: (031) 719-7806</span>
              </p>
            </div>
          </div>
<!--          <div class="location-map-box map02 pt-10">-->
<!--            &lt;!&ndash; <iframe width="100%" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.7230805809663!2d126.89658471564707!3d37.51444893486646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9ff70961aa95%3A0xae4024d663472891!2z7JeQ7J207Iqk7ZWY7J207YWM7YGs7Iuc7Yuw!5e0!3m2!1sko!2skr!4v1617349205843!5m2!1sko!2skr" allowfullscreen=""></iframe> &ndash;&gt;-->

<!--            <div id="daumRoughmapContainer1647588735404" class="root_daum_roughmap root_daum_roughmap_landing" style="width:100%; height:450px;"></div>-->
<!--            <div class="d-block d-md-flex px-5 px-sm-15 py-5 py-sm-8">-->
<!--              <h4 class="text-h5 text-md-h4 font-weight-bold">-->
<!--                <img src="@/assets/logo_header_d.svg">-->
<!--                지사-->
<!--              </h4>-->
<!--              <p>-->
<!--                <span>(06729) 서울 서초구 효령로 424 대명빌딩 301호</span>-->
<!--                 <span>(07299) 서울특별시 영등포구 경인로 775 에이스하이테크시티(문래동3가, 1동 707-1호)</span> -->
<!--                <span>Tel: (02) 6951-3106</span>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->

        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'location',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".location .sub-body-title", {
      scrollTrigger: {
        trigger: ".location .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".location-map-box.map01", {
      scrollTrigger: {
        trigger: ".location-map-box.map01",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3,
    });
    gsap.from(".location-map-box.map02", {
      scrollTrigger: {
        trigger: ".location-map-box.map02",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3,
    });

    // var container = document.getElementById('map');
    // var options = {
    //   center: new kakao.maps.LatLng(33.450701, 126.570667),
    //   level: 3
    // };
    // var map = new kakao.maps.Map(container, options);
    new daum.roughmap.Lander({
      "timestamp" : "1643244156194",
      "key" : "28xru",
      "mapWidth" : "100%",
      "mapHeight" : "450"
    }).render();

    new daum.roughmap.Lander({
      "timestamp" : "1647588735404",
		  "key" : "29igh",
      "mapWidth" : "100%",
      "mapHeight" : "450"
    }).render();
  },

  methods: {

  }

};
</script>

<style scoped>
</style>
